import React, { Component } from 'react';
//styles
import '../../static/fonts/Rubik/stylesheet.css'
import './header.scss';
import { scrollDown } from '../../static/scrollAnimation';
import { GA_Event } from '../Analytics/Analytics';
import { isMobile, isIos } from '../../static/helper';
import FlipCounter from '../FlipCounter/FlipCounter';

const eurovisionTotalDays = Math.ceil((new Date(2019, 4, 14) - new Date()) / (1000 * 60 * 60 * 24));

class Header extends Component {
  state = {
    transform: -100,
    shareUrl: "https://z.ynet.co.il/mshort/content/Eurovision2019/",
    showSelectTransform: false,
    isDecadeMenuVisible: false,
    decadeIdTransform: 45,
    isShowFixedMenu: false,
  }
  negishut() {
    document.getElementById('INDmenu-btn').click();
  }
  shareFacebook = () => {
    window.open("https://www.facebook.com/share.php?u=" + this.state.shareUrl, '_blank', "width=500,height=300");
    this.props.sendGA("Share_Facebook", this.state.shareUrl);
  }
  // shareTwitter = () => {
  //   let title = "אירוויזיון 2019 - ynet";
  //   let description = 'ynet מזמינים אתכם להתעדכן בכל מה שחם במתחם הרשמי של האירוויזיון 2019 בישראל שיתקיים בתל אביב. בואו לשמוע את השירים ולהצביע לחביב הקהל.'
  //   let url = 'https://twitter.com/intent/tweet?text=' + title + " " + description + "%0A" + this.state.shareUrl;
  //   window.open(url, '_blank', "width=500,height=300");
  //   this.props.sendGA("Share_Twitter", this.state.shareUrl);
  // }
  shareWhatsapp = () => {
    let url = '';
    if (isMobile() || isIos()) {
      url = `whatsapp://send?text=${this.state.shareUrl}`;
      window.open(url, "_parent");
    } else {
      url = `https://api.whatsapp.com/send?phone=&text=${this.state.shareUrl}`
      window.open(url, "_blank");
    }
    // let url = `whatsapp://send?text=${this.state.shareUrl}`;
    // window.open(url, '_blank', "width=500,height=300");
    this.props.sendGA("Share_Whatsapp", url);
  }

  sendMail = () => {
    this.props.sendGA("Write_Mail", '');
  }
  showMenu = () => {
    this.setState(prevState => ({
      isMenuShow: !prevState.isMenuShow
    }));
  }

  componentDidMount() {
    window.addEventListener('scroll', () => this.handleScroll(this.state.isDecadeMenuVisible, this.showDecadeMenu));
  }

  handleScroll() {
    if (window.scrollY > 0) {
      this.showFixedMenu(true);
    }
    else {
      this.showFixedMenu(false)
    }
  }

  showFixedMenu(show) {
    this.setState({
      isShowFixedMenu: show
    });
  }

  onMenuClick(page, title) {
    scrollDown(`${page}`, -100);
    this.showMenu();
    GA_Event("Navigation", title)
  }

  onTitleClick = () => {
    if (this.props.isArticle) {
      window.open('./#/', "_self")
    }
    else {
      scrollDown("section1-container", -100);
    }
  }

  render() {
    return (
      <div className={this.props.isArticle ? "article-menu" : ""}>
        <div className={this.state.isShowFixedMenu || this.props.isArticle ? "share-container fixed" : "share-container"}>
          <div className={this.state.isMenuShow === true ? "menu show" : this.state.isMenuShow === false ? "menu hidden" : "menu"}>

            <div className={this.state.isMenuShow ? "mobile-menu-icon show" : "mobile-menu-icon"} onClick={this.showMenu}>
              <div className="first"></div>
              <div className="second"></div>
              <div className="third"></div>
            </div>
            <div className="main-img-header" onClick={() => window.open('https://ynet.co.il', '_blank')}></div>
            {eurovisionTotalDays > 0 ?
              <div className="center">
                <span className="more">עוד</span>
                <FlipCounter eurovisionTotalDays={eurovisionTotalDays} />
                <span>יום זה מתחיל!</span>
              </div>
              :
              eurovisionTotalDays === 0 ?
                <div className="center today">היום זה מתחיל!</div>
                : ""
            }
            <a href="https://eurovision.tv/event/tel-aviv-2019" target="_blank" className="eurovision-logo"></a>
            {this.props.isArticle ?
              <div className="main-img-title" onClick={this.onTitleClick}>היית פעם אחרת</div>
              : ""
            }
            < div className="menu-icon"></div>
            <ul className="menu-list" id="menu" >
              {
                this.props.isArticle ?
                  <div onClick={() => window.open('./#/', "_self")}><li className="go-back"><span>חזרה לעמוד הראשי {/*<div className="arrow"></div> */}</span></li></div>
                  : ""
              }

              <a href="https://redmail.ynet.co.il" onClick={this.sendMail} target="_blank">
                {/* <li className="write-us"><span>כתבו לנו</span></li> */}
              </a>

            </ul>
            <a className={this.props.isArticle ? "return-home" : "return-home hide"} href="./#/" target="_self">{'>'}</a>
            <ul className="menu-container">
              <li className="menu-lis" onClick={() => this.onMenuClick("slider-container", "חדשות")}>חדשות</li>
              {/* <li className="menu-line"></li> */}
              <li className="menu-lis" onClick={() => this.onMenuClick("video-section", "דוז פואה")}>דוז פואה</li>
              {/* <li className="menu-line"></li> */}
              <li className="menu-lis" onClick={() => this.onMenuClick("gallery-section", "ישראל באירוויזיון")}>ישראל באירוויזיון</li>
              {/* <li className="menu-line"></li> */}
              <li className="menu-lis" onClick={() => this.onMenuClick("spotIm", "הזירה שלכם")}>הזירה שלכם</li>
              <li className="share">
                <a href="https://redmail.ynet.co.il" onClick={this.sendMail} target="_blank">
                  <div className="write-us"><span>כתבו לנו</span></div>
                </a>
                {/* <div className="twitter" onClick={this.shareTwitter}></div> */}
                <div className="whatsapp" onClick={this.shareWhatsapp}></div>
                <div className="facebook" onClick={this.shareFacebook}></div>
                <div className="accessibility" onClick={this.negishut}></div>
              </li>
            </ul>
          </div>
        </div>
      </div >
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/Components/Header/Header.js